<template>
    <div class="dashboard-container">
        <div class="dashboard-hero">
            <div class="dashboard-hero__content">
                <h1 class="dashboard-hero__title">Visão Geral</h1>
                <p class="dashboard-hero__subtitle">Acompanhe rapidamente os principais indicadores e ative ações frequentes.</p>
            </div>
        </div>
        <b-tabs content-class="mt-3" fill v-if="exibir">
            <b-tab title="Dashboard Almoxarifado" active v-if="mostrar[0]">
                <div class="tab-content">
                    <almoxarifado-dashboard />
                </div>
            </b-tab>

            <b-tab title="Dashboard Patrimônio" v-if="mostrar[1]">
                <div class="tab-content">
                    <patrimonio-dashboard />
                </div>
            </b-tab>

            <b-tab title="Dashboard Atas" v-if="mostrar[2]">
                <div class="tab-content">
                    <ata-dashboard />
                </div>
            </b-tab>
            <b-tab title="Dashboard Contratos" v-if="mostrar[3]">
                <div class="tab-content">
                    <ContratoDashboard />
                </div>
            </b-tab>

        </b-tabs>
    </div>
</template>

<script>
import AtaDashboard from '@/modules/ata-registro-preco/AtaDashboard.vue';
import PatrimonioDashboard from './PatrimonioDashboard.vue';
import ResourceService from "@/core/api/ResourceService";
import ContratoDashboard from './ContratoDashboard.vue';
import AlmoxarifadoDashboard from './AlmoxarifadoDashboard.vue';

export default {
    name: 'DashboardPage',
    components: {
        AlmoxarifadoDashboard,
        AtaDashboard,
        ContratoDashboard,
        PatrimonioDashboard
    },
    data() {
        return {
            exibir: false,
            mostrar: [false, false, false, false]
        }
    },
    methods: {
        async quaisExibir() {
            var { data } = await new ResourceService("/api/configuracoes-sistema").get('282');
            if (data.valorPropriedade == null || data.valorPropriedade == "") {
                this.mostrar = [true, true, false, false]
            }
            else {
                this.mostrar = data.valorPropriedade
                    .split(';')
                    .filter(v => v !== '')
                    .map(v => v === '1');
            }
        }
    },
    async beforeMount() {
        var { data } = await new ResourceService("/api/configuracoes-sistema").get('278');
        this.exibir = data.valorPropriedade == '1';
        this.quaisExibir();
    }
};
</script>

<style scoped>
.dashboard-container {
    padding: 20px;
}

.dashboard-hero {
    background: linear-gradient(135deg, rgba(36, 82, 141, 0.12) 0%, rgba(36, 82, 141, 0.06) 100%);
    border: 1px solid rgba(36, 82, 141, 0.18);
    border-radius: 12px;
    padding: 18px 20px;
}

.dashboard-hero__title {
    margin: 0 0 4px 0;
    font-size: 20px;
    font-weight: 700;
}

.dashboard-hero__subtitle {
    margin: 0;
    font-size: 13px;
    color: #6c757d;
}
</style>
